import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-2" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "flex flex-col items-center justify-center h-screen text-center error-page lg:flex-row lg:text-left" }
const _hoisted_4 = { class: "-intro-x lg:mr-20" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "mt-10 text-white lg:mt-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium intro-x text-8xl" }, "Not Authorized", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5 text-xl font-medium intro-x lg:text-3xl" }, " Oops. You do not have access to see this page. ", -1)

import errorIllustration from "../assets/images/error-illustration.svg";
import Button from "../base-components/Button";
import { onMounted } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'NotAuthorized',
  setup(__props) {

onMounted(async () => {
  if(localStorage.getItem("theme")) {
    //@ts-ignore
        const theme = JSON.parse(localStorage.getItem("theme"));
        let colorScheme = theme.colorScheme;
        if(document.body.classList.length == 0) {
        document.body.classList.add(colorScheme);
        }
      }
});
function goToHomepage() {
  location.href = "/management";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            alt: "Midone Tailwind HTML Admin Template",
            class: "w-[450px] h-48 lg:h-auto",
            src: _unref(errorIllustration)
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _createVNode(_unref(Button), {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goToHomepage())),
            class: "px-4 py-3 mt-10 text-white border-white intro-x dark:border-darkmode-400 dark:text-slate-200"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Back to Home ")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})